import { render, staticRenderFns } from "./SectionLiveVideo.vue?vue&type=template&id=6edee981&scoped=true&"
import script from "./SectionLiveVideo.vue?vue&type=script&lang=js&"
export * from "./SectionLiveVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edee981",
  null
  
)

export default component.exports